import React, { useState,useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './index.css';
import { imageBaseUrl } from '../../utils/constants';

export function SuccessPage() {
  const [text, setText] = useState('Record Updated Successfully!');
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.state.stateVal;

  useEffect(() => {
    location?.state?.text && setText(atob(location?.state?.text));
  }, []);
  
  return (
    <div className='success-page'>
        <img src={`${imageBaseUrl}/tick1.png`} alt="tick" />
        <span className='success-page-title'>{text}</span>
        <button data-testid="SuccessPage" className='success-page-btn' onClick={()=>navigate(path)}>Proceed</button>
    </div>
  )
}

export default SuccessPage;